(function () {
  var VERSION = "1.0.0";
  var cache = new Map();

  if (window.VidaLabsHeroProofOnly && window.VidaLabsHeroProofOnly.version === VERSION) {
    window.VidaLabsHeroProofOnly.scan();
    return;
  }

  function text(value, fallback) {
    if (value === null || value === undefined) return fallback || "";
    return String(value).trim() || fallback || "";
  }

  function html(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function field(item, names, fallback) {
    for (var i = 0; i < names.length; i += 1) {
      if (text(item && item[names[i]])) return item[names[i]];
    }
    return fallback || "";
  }

  function safeUrl(value) {
    var url = text(value);
    return /^(https?:|mailto:|tel:)/i.test(url) ? url : "";
  }

  function initials(name) {
    return text(name)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) {
        return part.charAt(0).toUpperCase();
      })
      .join("") || "VL";
  }

  function normalize(payload) {
    var list = Array.isArray(payload)
      ? payload
      : payload && (payload.profesionales || payload.doctores || payload.items || payload.data);

    if (!Array.isArray(list)) return [];

    return list.map(function (item) {
      return {
        name: text(field(item, ["nombre", "name", "full_name"])),
        photo: safeUrl(field(item, ["foto", "photo", "image", "avatar"]))
      };
    }).filter(function (person) {
      return person.name;
    });
  }

  function load(source) {
    if (!source) return Promise.resolve([]);
    if (!cache.has(source)) {
      cache.set(source, fetch(source, { credentials: "omit" })
        .then(function (response) {
          if (!response.ok) throw new Error("Professionals JSON unavailable");
          return response.json();
        })
        .then(normalize));
    }
    return cache.get(source);
  }

  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var random = window.crypto && window.crypto.getRandomValues
        ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296
        : Math.random();
      var j = Math.floor(random * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function avatar(person) {
    var label = html(person.name);
    if (person.photo) {
      return '<span class="vl-hero-copy-vc__avatar"><img src="' + html(person.photo) + '" alt="' + label + '" loading="lazy"></span>';
    }
    return '<span class="vl-hero-copy-vc__avatar"><span>' + html(initials(person.name)) + '</span></span>';
  }

  function hydrate(root) {
    if (!root || root.dataset.vlHeroProofReady === "true") return;
    root.dataset.vlHeroProofReady = "true";

    load(root.dataset.professionalsSource)
      .then(function (people) {
        var target = root.querySelector("[data-vl-hero-avatars]");
        if (!target || !people.length) return;
        target.innerHTML = shuffle(people).slice(0, 3).map(avatar).join("");
      })
      .catch(function () {
        root.classList.add("vl-hero-copy-vc--people-error");
      });
  }

  function scan() {
    document.querySelectorAll("[data-vl-hero-proof]").forEach(hydrate);
  }

  window.VidaLabsHeroProofOnly = {
    version: VERSION,
    scan: scan
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
})();
